import { PackingMethodService, ZoneService } from '@gtpl/shared-services/masters';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { FGStockService } from '@gtpl/shared-services/warehouse-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { RmRackRepository } from '../rm-racks/dto/rm-rack-repository';
import { RmRackAdapter } from '../rm-racks/dto/rm-racks.adapter';
import { RmRacksService } from '../rm-racks/rm-racks.service';
import { RmRackPositionController } from './rm-rack-position.controller';
import { RmRackPosition } from './rm-rack-position.entity';
import { RmRackPositionRepository } from './rm-rack-position.repo';
import { RmRackPositionService } from './rm-rack-position.service';


@Module({
  imports: [
    TypeOrmModule.forFeature([RmRackPosition,RmRackRepository,RmRackPositionRepository]),
  ],
  controllers: [RmRackPositionController],
  providers: [RmRackPositionService,ApplicationExceptionHandler,PackingMethodService,SaleOrderService,FGStockService,ZoneService,RmRacksService,RmRackAdapter,LogsService]
})
export class RmRackPositionModule {}
